export default {"src":"/_next/static/media/arrow-icon.d41dd19e.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};